import { InputRule } from '@milkdown/kit/prose/inputrules';
import { $inputRule } from '@milkdown/kit/utils';
import { replace } from 'out-of-character';

import { embedNode } from '../embed';
import { VIMEO_REGEX } from '../providers/vimeo';

/**
 * Input rule: pasting/typing a Vimeo URL creates an embed block
 */
export const vimeoInputRule = $inputRule(
  (ctx) =>
    new InputRule(VIMEO_REGEX, (state, match, start, end) => {
      const [rawUrl] = match;
      if (!rawUrl) return null;

      const url = replace(rawUrl);
      const { tr } = state;

      tr.replaceWith(start, end, embedNode.type(ctx).create({ href: url, embedType: 'vimeo' }));

      return tr;
    }),
);
